import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LocationViewChoices, WIDGET_SETTING_CHOICE } from '@/constants/enum';

const initialState = {
  locationTab: LocationViewChoices.ALL,
  widgetTab: WIDGET_SETTING_CHOICE.POSITION,
};

type TabState = typeof initialState;

const tabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    handleLocationTab<K extends keyof TabState>(state: TabState, action: PayloadAction<{ key: K; value: TabState[K] }>) {
      state[action.payload.key] = action.payload.value;
    },
  },
});

export const locationTabSelector = createSelector(
  (state: RootState) => state.tab,
  (state) => state.locationTab,
);

export const widgetTabSelector = createSelector(
  (state: RootState) => state.tab,
  (state) => state.widgetTab,
);

export const { handleLocationTab } = tabSlice.actions;

export default tabSlice;
